import { Routes } from '@angular/router';

/**
 * Routes of the deprecated document model (DWRM /v1/documents, which v2 does not have). Its views
 * are gone; links to them live on in bookmarks and in notifications already sent (v1 and v2
 * DocumentNotificationOrigin link disposers to /enb/dokumente/form), so they lead to the v2 views.
 * Old document ids stay valid there: v2 finds migrated documents by their v1 id.
 */
export const LEGACY_DOCUMENT_REDIRECTS: Routes = [
  { path: 'aez/dokumentev1', pathMatch: 'full', redirectTo: '/aez/dokumente' },
  { path: 'aez/dokumentev1/:id', redirectTo: '/aez/dokumente/:id' },
  {
    path: 'aez/dokumente/form',
    pathMatch: 'full',
    redirectTo: '/aez/dokument-management',
  },
  {
    path: 'aez/dokumente/form/:id',
    redirectTo: '/aez/dokument-management/:id',
  },
  {
    path: 'enb/dokumente/form',
    pathMatch: 'full',
    // a function, so the query (companyId, orderId) comes along
    redirectTo: ({ queryParams }) =>
      `/enb/dokument-management${toQuery(queryParams)}`,
  },
];

function toQuery(queryParams: Record<string, string>): string {
  const query = new URLSearchParams(queryParams).toString();
  return query ? `?${query}` : '';
}
